<template>

<ui-button-options v-on:click.native.stop="viewPdf(item)" :title="item.title">

      <div slot="left"><ui-icon color="#B4B4B4" backgroundColor="transparent" class="email-icon" icon="paperclip"></ui-icon></div>
   </ui-button-options>

</template>

<script>
import UiButtonOptions from '../UiButtonOptions.vue';

import UiIcon from '../UiIcon.vue';
import { USER_LEVEL } from '../../settings/USER_LEVEL.js';
import { mapState } from 'vuex';

import { fileSave } from '../../services/FileSave.js';



export default {
  name: 'button-newsletter',
  props:{
    item:{default:{}},
  },
  data:function(){
    return {
    }
  },
  computed:{
    ...mapState([
       'appSettings'
      ]),
    computeUserAccess(){
         // only existing in global
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       }
  },
  methods:{
    viewPdf(media){
      
      var fileName=media.title;
      // why the title has no .pdf attached here?
      if(!media.title.includes(".pdf")){
        fileName+=".pdf";
      }
      
      
      this.$store.dispatch('get_crossdomain_download',{newsl_id:media.id,fileName:media.filename}).then(
        result=>{
          var base64data= "data:application/pdf;base64,"+result.data.base64Data;
          fileSave.saveBase64ToFile(base64data, fileName);
      })
      
    },
  },
  mounted:function(){
    
  },
  components:{
    UiButtonOptions,
    //UiOption
    UiIcon,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-icon{
  display:block;
  height: 50px;
  width: 50px;
  border-radius: 9999px;
  border: 1px solid #707070;
}
</style>
